<template>
  <Highcharts
    ref="chart"
    v-bind="$attrs"
    :options="mergedOption"
    v-on="$listeners"
  />
</template>

<script>
import { deepMerge } from '@/utils/object';
import Highcharts from '@@/common/stats/Highcharts';
import lang from '@/mixins/lang';

export default {
  name: 'BaseChart',
  components: {
    Highcharts,
  },
  mixins: [lang],
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    baseChartOptions() {
      const isPersian = this.lang === 'fa';
      const align = isPersian ? 'right' : 'left';
      const font = isPersian ? 'IRANSans' : 'EnIRANSans';
      return {
        chart: {
          type: 'area',
          style: {
            fontFamily: font,
          },
        },
        title: {
          text: null,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          shared: true,
          style: {
            textAlign: align,
          },
          useHTML: true,
          pointFormat: isPersian
            ? '{series.name}: <b>{point.y}</b> <span style="color:{point.color}">\u25CF</span><br/>'
            : '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
        },
        legend: {
          rtl: isPersian,
        },
        plotOptions: {
          series: {
            fillOpacity: 0.4,
          },
          area: {
            stacking: 'normal',
          },
        },
      };
    },
    mergedOption() {
      return deepMerge(this.baseChartOptions, this.options);
    },
  },
};
</script>
